import { createSelector } from 'reselect';
import { resolveTabletkaLoc } from '../i18n';
import { getCurrentLocation } from './location';

export const getTabletkaLocation = createSelector(
    [getCurrentLocation],
    currentLoc => resolveTabletkaLoc(currentLoc?.code),
);
